import React from 'react';
import AsyncOpenHelpPanelLinkThroughEventListener from '@atlassian/jira-help-panel-button/src/async.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import AsyncLegacyTeamProfileCard from '@jira/platform__profilecard-next/src/ui/team-profilecard-legacy/async.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';

type Props = RouteContext;

export const LegacyPageWithTeamProfileCardView = (props: Props): React.JSX.Element => (
	<>
		<LegacyPage {...props} />

		<AsyncOpenHelpPanelLinkThroughEventListener />

		<AsyncLegacyTeamProfileCard />
	</>
);
